<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { NuxtIcon } from '#components';
import { useSmarticoUserInfos } from '~/stores/smartico/userInfos';
import { useAuthStore } from '~/stores/auth';
import { useSmarticoInit } from '~/stores/smartico/init';

const userInfosStore = useSmarticoUserInfos();
const { userInfosProfile } = storeToRefs(userInfosStore);
const { isAuthenticated } = storeToRefs(useAuthStore());
const { loadUserInfosProfile } = userInfosStore;
const { isReadyGamefication } = storeToRefs(useSmarticoInit());

const { walletRealFormatted, walletBonusFormatted } = useWallet();

const emit = defineEmits(['close']);

const handleBalanceClick = () => {
  emit('close');
};

onMounted(() => {
  if (isAuthenticated.value) {
    loadUserInfosProfile();
  }
});

watch(isAuthenticated, (v) => {
  if (v) {
    loadUserInfosProfile();
  }
});

watch(isReadyGamefication, (v) => {
  if (v) {
    loadUserInfosProfile();
  }
});

const currencies = computed(() => {
  return [
    {
      name: 'COINS',
      value:
        userInfosProfile?.value?.ach_points_balance?.toLocaleString('pt-BR') ??
        '0',
      icon: 'currency-header/coin',
    },
    {
      name: 'DIAMONDS',
      value:
        userInfosProfile?.value?.ach_diamonds_balance?.toLocaleString(
          'pt-BR',
        ) ?? '0',
      icon: 'currency-header/diamond',
    },
    {
      name: 'GEMS',
      value:
        userInfosProfile?.value?.ach_gems_balance?.toLocaleString('pt-BR') ??
        '0',
      icon: 'currency-header/gem',
    },
  ];
});
</script>

<template>
  <div class="currency-dropdown-container">
    <div class="dropdown-arrow"></div>
    <div class="currency-dropdown">
      <div
        class="balance-item hover:cursor-pointer hover:opacity-90"
        @click="handleBalanceClick"
      >
        <div class="balance-value">{{ walletRealFormatted }}</div>
        <div class="balance-label">SALDO REAL</div>
      </div>

      <div
        class="balance-item hover:cursor-pointer hover:opacity-90"
        @click="handleBalanceClick"
      >
        <div class="balance-value">{{ walletBonusFormatted }}</div>
        <div class="balance-label">SALDO BÔNUS</div>
      </div>

      <div
        v-for="currency in currencies"
        :key="currency.name"
        class="currency-item"
      >
        <NuxtIcon
          class="currency-icon"
          filled
          :name="currency.icon"
        />
        <div class="currency-info">
          <div class="currency-value">{{ currency.value }}</div>
          <div class="currency-label">{{ currency.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.currency-dropdown-container {
  position: relative;
}

.dropdown-arrow {
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 4px 0 0 0;
}
.currency-dropdown {
  display: inline-flex;
  min-width: 130px;
  max-width: 320px;
  width: auto;
  min-height: 206px;
  height: auto;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 7px;
  border-radius: 5px;
  background: #fff;
}

.balance-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 37px;
  padding: 5px 8px;
  background: #e5e5e5;
  border-radius: 5px;

  .balance-value {
    font-size: 12px !important;
    font-weight: 700;
    color: #000;
    line-height: 1.2;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
  }

  .balance-label {
    font-size: 9px;
    font-weight: 600;
    color: #9ca3af;
    text-align: center;
    margin-top: 2px;
  }
}

.currency-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  .currency-icon {
    font-size: 32px;
    flex-shrink: 0;
  }

  .currency-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .currency-value {
    font-size: 12px !important;
    font-weight: 700;
    color: #000;
    line-height: 1;
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
  }

  .currency-label {
    font-size: 9px;
    font-weight: 600;
    color: #9ca3af;
  }
}
</style>
